module.exports = __webpack_public_path__ + "img/1.e0c0c450.jpg";